import React from 'react'
import { observer } from 'mobx-react-lite'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import Header from '../Header/Header'
import { NOTIFICATION_OPTIONS } from './notificationOptions'
import s from './Notifications.module.scss'

const renderToggleControl = ({
	showSkeleton,
	hasLoadError,
	isSaving,
	isChecked,
	onToggle,
}) => {
	if (showSkeleton) {
		return (
			<span className={s.notifications__toggleSkeleton} aria-hidden="true">
				<LoaderImg />
			</span>
		)
	}

	if (hasLoadError) {
		return (
			<span className={s.notifications__unavailable} aria-hidden="true">
				—
			</span>
		)
	}

	return (
		<>
			<input
				className={s.notifications__input}
				type="checkbox"
				checked={isChecked}
				disabled={isSaving}
				onChange={onToggle}
			/>
			<i className={s.notifications__toggle} aria-hidden="true" />
		</>
	)
}

export const Notifications = observer(({
	activeNotifications,
	notifications,
	toggleNotification,
	goBack,
	notificationsLoadStatus,
	notificationsSaveStatus,
	notificationsError,
}) => {
	const showSkeleton =
		notificationsLoadStatus === 'idle' || notificationsLoadStatus === 'loading'
	const hasLoadError = notificationsLoadStatus === 'error'
	const isLoaded = notificationsLoadStatus === 'success'
	const isSaving = notificationsSaveStatus === 'saving'

	return (
		<>
			<Header
				title="Notification preferences"
				description="Choose which updates you want to see in your notifications."
				onBack={goBack}
			/>
			<div className={s.notifications__head}>
				<p className={s.notifications__summary}>
					{showSkeleton ? (
						<span
							className={s.notifications__summarySkeleton}
							aria-busy="true"
							aria-label="Loading notification summary"
						>
							<LoaderImg />
						</span>
					) : hasLoadError ? (
						<strong>Notification preferences unavailable</strong>
					) : (
						<strong>{activeNotifications} notification types on</strong>
					)}
				</p>
				<p className={s.notifications__hint}>
					{hasLoadError
						? 'Preferences could not be loaded. Try again later.'
						: 'You can turn any type on or off at any time.'}
				</p>
				{notificationsError ? (
					<p className={s.notifications__error} role="alert">
						{notificationsError}
					</p>
				) : null}
			</div>
			<section
				className={s.notifications__card}
				aria-busy={showSkeleton ? 'true' : undefined}
			>
				<div className={s.notifications__list}>
					{NOTIFICATION_OPTIONS.map(option => {
						const Icon = option.icon
						const RowTag = isLoaded ? 'label' : 'div'

						return (
							<RowTag
								key={option.id}
								className={`${s.notifications__row}${!isLoaded ? ` ${s.notifications__row_skeleton}` : ''}`.trim()}
							>
								<span
									className={`${s.notifications__icon} ${s[`notifications__icon--${option.tone}`]}`}
								>
									<Icon aria-hidden />
								</span>
								<span className={s.notifications__copy}>
									<strong className={s.notifications__rowTitle}>{option.title}</strong>
									<small className={s.notifications__rowText}>{option.text}</small>
								</span>
								{renderToggleControl({
									showSkeleton,
									hasLoadError,
									isSaving,
									isChecked: Boolean(notifications[option.id]),
									onToggle: () => toggleNotification(option.id),
								})}
							</RowTag>
						)
					})}
				</div>
			</section>
		</>
	)
})

export default Notifications
